import Swiper from "swiper";
import { Navigation, Pagination, Autoplay, EffectCreative, FreeMode, Thumbs } from "swiper/modules";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import { Config } from "../settings/config.es6";

gsap.registerPlugin(ScrollTrigger);

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const WINDOW_WIDTH = Config.WINDOW_WIDTH;

export default class Slider {
    constructor(target, option) {
        this.target = target;
        this.option = option;
        this.swiperInstance;
        this.init();
    }

    init() {
        if(!this.target) return;

        const baseModules = [Navigation, Pagination, Autoplay, EffectCreative];
        if (this.option && this.option.freeMode) {
            baseModules.push(FreeMode);
        }
        if (this.option && this.option.thumbs) {
            baseModules.push(Thumbs);
        }

        this.swiperInstance = new Swiper(this.target, {
            ...this.option,
            modules: baseModules,
            observer: true,
            observeParents: true,
            resizeObserver: true,
            passiveListeners: false,
            on: {
                init(swiper) {
                    swiper.update();
                },
            },
        });
    }
}
